import COMMON_CONSTS from '../consts/common/index'

export default function (app) {
	app.directive('euVatNumber', function () {
		let euvatRegexp = COMMON_CONSTS.EUVAT_REGEXP;
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {
				let validateEUNumber = viewValue => {
					if (viewValue) {
						let isValid = euvatRegexp.test(viewValue);
						if (isValid && viewValue.length >= 10 && viewValue.length <= 13) {
							angular.element('#euvatnumberinvalid').css('display', 'none');
						} else {
							angular.element('#euvatnumberinvalid').css('display', 'block');
						}
					} else {
						angular.element('#euvatnumberinvalid').css('display', 'none');
					}
					return viewValue;
				};
				ctrl.$parsers.unshift(validateEUNumber);
				ctrl.$formatters.unshift(validateEUNumber);
			}
		};
	});
};
